module.exports = __webpack_public_path__ + "static/img/bonus_1.c30d71f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lhzb/bonus_1.png
// module id = FDxc
// module chunks = 0